import React,{useState} from 'react';
import * as ReactDOM from 'react-dom';
import { getmessage,reducearray,arrprtojson } from './Dynamictable';

export const postapplyads = ()=>{
return(
<div className="per100">
			 <div className="search-title-bar">
                       	<div className="search-title">
			  Join Sales executive

			</div>
			<a href="#" onClick={e => aminitclose()} title="Aminities">
			<div className="search-title-toggle" id="togglesearch">
			  X
			</div>
			</a>
	   	     </div>
		    <div className="Sikaamsgbody" style={{backgroundColor:'#bfd3d3'}}>
		     <div style={{width:'100%',display:'table'}} >	
			<div className="Sikaamsginerbody" style={{backgroundColor:'#bfd3d3',width:'90%'}}>
			Follow Steps to Join Sales executive

		        </div>
                      </div>
		     <div style={{width:'100%',display:'table'}}>	
			<div className="Sikaamsginerbody" style={{backgroundColor:'#bfd3d3',width:'90%'}}>
			<ul>
			<li>First time Sign up
			</li>
			<li>Authorized Login
			</li>
			<li>Go to Profile
			</li>
			<li>Click on Offers
			</li>
			<li>Click on Apply Sales Executive
			</li>
			<li>Click on Accepted and Join
			</li>

		        </ul>
		        </div>
		    </div>
		  
		    </div>
		
		</div>
);
}
export const aminitclose=()=>{
 const Pdivr = document.getElementById('customemsgdiv') as HTMLElement;
		Pdivr.style.display = 'none';
	
}
